import { differenceInYears } from 'date-fns';
import { getVarianteFromPossibleValues } from '../../../../helpers/variant.utils';
import '../RadioTab.css';
import { RadioTabContentProps } from '../RadioTab.types';
import { RadioTabContentData, RadioTabContentDataGreater50 } from '../RadioTabData';
import RadioTabBenefit from './RadioTabBenefit';
import RadioTabCheckbox from './RadioTabCheckbox';

const RadioTabContent = (props: RadioTabContentProps) => {
  let age = 0;
  if (props.birthdate && props.inceptionDate) {
    age = differenceInYears(new Date(props.inceptionDate), new Date(props.birthdate));
  }

  const contentData = age > 50 ? RadioTabContentDataGreater50 : RadioTabContentData;

  const variantData =
    contentData
      .map(data => ({ ...data, title: `${getVarianteFromPossibleValues(data.variant, props.tariffTypeValues?.possibleValues)} ${data.title}` }))
      .filter(data => data.variant === props.variant)
      [0];

  return <div className="tab-content">
    <RadioTabBenefit {...props} {...variantData} />
    <RadioTabCheckbox {...props} />
  </div>;
};

export default RadioTabContent;
